import { UntypedFormGroup } from "@angular/forms";
import moment from "moment";

export const getCustomValidatorsMovementNavigationPlan = (): ((group: UntypedFormGroup) => null | any)[] => {
  return [
    returnDatetimeAfterExecutionDatetime
  ]
}

const returnDatetimeAfterExecutionDatetime = (group: UntypedFormGroup) => {
  const form = group.value
  // Se não tiver returnTime no formulário, não aplicar validação
  // Isso resolve o problema para movimentações avulsas (SINGLE)
  if (!('returnTime' in group.controls)) {
    return null;
  }
  
  if (form.executionDate && form.returnTime) {
    const executionDate = moment(form.executionDate);
    const returnTime = moment(form.returnTime);
    if (executionDate.isSameOrAfter(returnTime)) {
      return { returnTimeNotBeforeExecutionError: true }
    }
  }
  return null;
}
